<template>
  <div class="thumb">
    <img @error="thumbLoadError" @load="thumbLoaded" :src="src">
    <slot></slot>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { eventBus } from '../../services/EventBus.js';

export default {
  name: 'scroll-image',
  props:{
    src:{default:""},
  },
  data(){
    return {
     
    }
  },
  computed:{
    ...mapState(['appSettings']),
   
  },
  methods:{
    thumbLoadError(e){
      e.target.src=require('../../assets/thumb_404.png');
    },
    thumbLoaded(){
      
      eventBus.$emit('UPDATE_SCROLLMENU');
    },
   
  },// methods
  components:{
  },
  
  
  mounted(){
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.thumb{
  position:relative;
  padding:1px;
  display:inline-block;
  cursor:pointer;
  border-width:3px;
  border:2px solid #000000;
  margin:2px;
  transition: border .25s;
}
.thumb img{
  display:block;
  position:relative;
  height:80px;
  width:auto;
}

</style>
